import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './HomeHotRow.scss'
import {withRouter} from "react-router-dom";

class HomeHotRow extends Component {
  render() {
    return (
      <div className='home-hot' onClick={this.speedWithMe}>
        <div className='home-hot-titleName'>
          <img src={this.props.rowData.logoImg} alt=""/>
          <p>{this.props.rowData.name}</p>
        </div>
        <div className='home-hot-content'>
          <div className='home-hot-content-left'>
              <p className='p_top'>{this.props.rowData.endQuota}</p>
              <p className='p_bottom'>额度(元)</p>
          </div>
          <div className='home-hot-content-center'>
            <p className='p_top'>{this.props.rowData.maxBrokerageRate}<span>{this.props.rowData.rateType ? "元":"%"}</span></p>
            <p className='p_bottom'>{this.props.rowData.rateType ? "提佣金额":"提佣比例"}</p>
          </div>
          <div className="home-hot-content-right">
            <div className="home-hot-content-right-btn">
              <p>我要推广</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
  speedWithMe = () => {
    console.log(this.props.rowData);
    this.props.history.push({
      pathname: "/inviteHome/custom",
      state: {
        codeText: this.props.rowData.code,
        productID: this.props.rowData.id,
      }
    });
  }
}

HomeHotRow.propTypes = {
  rowData: PropTypes.object,
}

export default withRouter(HomeHotRow);


